// Standard Library imports
import React, { useState } from 'react';

// Internal module imports
import TabsComponent from '../../components/Tabs/Tabs';
import Edge from './edge';
import EdgeError from './EdgeError/EdgeError';
import EdgeStats from './EdgeStats/EdgeStats';
import AWSAccessManager from './AWSAccessManager';
import System from './system';
import Dashboard from './Dashboard';
import UploadLogFiles from './UploadedLogFiles/UploadLogFiles';
import EdgeTestLogs from './EdgeTestLogs';
import Shipments from './Shipments/Shipments';
import EdgeGateway from './EdgeGateway/EdgeGateway';
import EdgeGatewayStats from './EdgeGatewayStats/EdgeGatewayStats';
import EdgeGatewayError from './EdgeGatewayError/EdgeGatewayError';
import UploadLogFilesGateway from './UploadedLogFilesGateway/UploadLogFilesGateway';
import EdgeConfigHistory from './EdgeConfigHistory/EdgeConfigHistory';
import EdgeFileUploadHistory from './EdgeFileUploadHistory/EdgeFileUploadHistory';
import EdgeIncidents from './EdgeIncidents/EdgeIncidents';
import { useQueryParamWithDefault } from '../../hooks';
import { NumberParam } from 'use-query-params';

const Resources = ({ customer, cId }) => {
    const [selectedIndex, setSelectedIndex] = useQueryParamWithDefault('subTab', NumberParam, 0, cId);
    const [edgeError, setEdgeError] = useState(false);
    const [edgeStats, setEdgeStats] = useState(false);
    const [edgeDeviceId, setEdgeDeviceId] = useState();
    const [edgeGatewayError, setEdgeGatewayError] = useState(false);
    const [edgeGatewayId, setEdgeGatewayId] = useState();
    const [edgeGatewayStats, setEdgeGatewayStats] = useState(false);
    const [selectedEdgeGateway, setSelectedEdgeGateway] = useState('');
    const [uploadLogFilesGateway, setUploadLogFilesGateway] = useState({
        status: false,
        data: '',
    });
    const [selectedEdge, setSelectedEdge] = useState('');
    const [dashboard, setDashboard] = useState({
        show: false,
        data: {},
    });
    const [uploadLogFiles, setUploadLogFiles] = useState({
        status: false,
        data: '',
    });
    const [edgeConfigHistory, setEdgeConfigHistory] = useState({
        status: false,
        data: '',
    });
    const [edgeUploadFilesHistory, setEdgeUploadFilesHistory] = useState({
        status: false,
        data: '',
    });
    const [edgeIncidents, setEdgeIncidents] = useState({
        status: false,
        data: '',
    });

    const [testLogs, setTestLogs] = useState({
        status: false,
        deviceId: '',
        market: '',
        edgeVersion: 'v0',
        testType: '',
    });

    const handleChangeTab = (i) => {
        setSelectedIndex(i);
        setEdgeError(false);
        setEdgeGatewayError(false);
        setEdgeStats(false);
        setEdgeGatewayStats(false);
        setDashboard({ status: false, data: {} });
        setUploadLogFiles({ status: false, data: '' });
        setUploadLogFilesGateway({ status: false, data: '' });
        setEdgeConfigHistory({ status: false, data: '' });
        setEdgeUploadFilesHistory({ status: false, data: '' });
        setEdgeIncidents({ status: false, data: '' });
        setTestLogs({ status: false, deviceId: '', market: '', edgeVersion: '', testType: '' });
    };

    let tabs = [
        {
            name: 'Edge Devices',
            component: (
                <>
                    <Edge
                        setSelectedIndex={setSelectedIndex}
                        setEdgeError={setEdgeError}
                        setEdgeDeviceId={setEdgeDeviceId}
                        setEdgeStats={setEdgeStats}
                        setDashboard={setDashboard}
                        setUploadLogFiles={setUploadLogFiles}
                        setEdgeConfigHistory={setEdgeConfigHistory}
                        setEdgeUploadFilesHistory={setEdgeUploadFilesHistory}
                        setEdgeIncidents={setEdgeIncidents}
                        setTestLogs={setTestLogs}
                        setSelectedEdge={setSelectedEdge}
                        customer={customer}
                    />
                </>
            ),
        },
        {
            name: 'Edge Gateway',
            component: (
                <>
                    <EdgeGateway
                        setSelectedIndex={setSelectedIndex}
                        setEdgeGatewayError={setEdgeGatewayError}
                        setEdgeGatewayId={setEdgeGatewayId}
                        setEdgeGatewayStats={setEdgeGatewayStats}
                        setUploadLogFilesGateway={setUploadLogFilesGateway}
                        setSelectedEdgeGateway={setSelectedEdgeGateway}
                        customer={customer}
                    />
                </>
            ),
        },
        {
            name: 'Systems',
            component: (
                <>
                    <System customer={customer} setSelectedIndex={setSelectedIndex} setEdgeError={setEdgeError} setEdgeDeviceId={setEdgeDeviceId} setEdgeStats={setEdgeStats} />
                </>
            ),
        },
        {
            name: 'AWS Credentials',
            component: (
                <>
                    <AWSAccessManager customer={customer} />
                </>
            ),
        },
        {
            name: 'Shipments',
            component: (
                <>
                    <Shipments customer={customer} />
                </>
            ),
        },
        ...(edgeError
            ? [
                  {
                      name: 'Edge Logs',
                      component: (
                          <>
                              <EdgeError edgeError={edgeError} edgeDeviceId={edgeDeviceId} selectedEdge={selectedEdge} />
                          </>
                      ),
                  },
              ]
            : []),
        ...(edgeGatewayError
            ? [
                  {
                      name: 'Edge Gateway Logs',
                      component: (
                          <>
                              <EdgeGatewayError edgeGatewayId={edgeGatewayId} selectedEdgeGateway={selectedEdgeGateway} />
                          </>
                      ),
                  },
              ]
            : []),
        ...(edgeStats
            ? [
                  {
                      name: 'Edge Stats',
                      component: (
                          <>
                              <EdgeStats edgeDeviceId={edgeDeviceId} />
                          </>
                      ),
                  },
              ]
            : []),
        ...(edgeGatewayStats
            ? [
                  {
                      name: 'Edge Gateway Stats',
                      component: (
                          <>
                              <EdgeGatewayStats edgeGatewayId={edgeGatewayId} />
                          </>
                      ),
                  },
              ]
            : []),
        ...(dashboard.show
            ? [
                  {
                      name: 'Dashboard',
                      component: (
                          <>
                              <Dashboard data={dashboard.data} />
                          </>
                      ),
                  },
              ]
            : []),
        ...(uploadLogFiles.status
            ? [
                  {
                      name: 'Edge Log Files',
                      component: (
                          <>
                              <UploadLogFiles deviceId={uploadLogFiles.data} setOpen={setUploadLogFiles} />
                          </>
                      ),
                  },
              ]
            : []),
        ...(uploadLogFilesGateway.status
            ? [
                  {
                      name: 'Edge Gateway Log Files',
                      component: (
                          <>
                              <UploadLogFilesGateway edgeGatewayId={uploadLogFilesGateway.data} setOpen={setUploadLogFilesGateway} />
                          </>
                      ),
                  },
              ]
            : []),
        ...(testLogs.status
            ? [
                  {
                      name: 'Edge Test Logs ',
                      component: (
                          <>
                              <EdgeTestLogs deviceId={testLogs.deviceId} market={testLogs.market} edgeData={testLogs} setTestLogs={setTestLogs} />
                          </>
                      ),
                  },
              ]
            : []),
        ...(edgeConfigHistory.status
            ? [
                  {
                      name: 'Edge Configuration History',
                      component: (
                          <>
                              <EdgeConfigHistory deviceId={edgeConfigHistory.data} setOpen={setEdgeConfigHistory} />
                          </>
                      ),
                  },
              ]
            : []),
        ...(edgeUploadFilesHistory.status
            ? [
                  {
                      name: 'Edge Uploads History',
                      component: (
                          <>
                              <EdgeFileUploadHistory edgeId={edgeUploadFilesHistory.data} setOpen={setEdgeUploadFilesHistory} />
                          </>
                      ),
                  },
              ]
            : []),
        ...(edgeIncidents.status
            ? [
                  {
                      name: 'Edge Incidents',
                      component: (
                          <>
                              <EdgeIncidents deviceId={edgeIncidents.data} setOpen={setEdgeIncidents} />
                          </>
                      ),
                  },
              ]
            : []),
    ];

    return (
        <div className=" ventilation">
            <TabsComponent selectedIndex={selectedIndex} tabs={tabs} onChangeTab={handleChangeTab} cId={cId} />
        </div>
    );
};

export default Resources;
